import { IEventLoggingComponentProps, withEventLogging } from '@AppModels/Logging';
import { StyleDeclarationValue, css } from 'aphrodite';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { IModalContext, ModalChildComponentContextKey } from '../../../../models';
import {
	FullScreenModalViewModelKey,
	IErrorMessageComponentProps,
	IUserSessionComponentProps,
} from '../../../../models/AppState';
import { CreateCampaignApprovalViewModel } from '../../../../viewmodels/AdminViewModels';
import { MultiContainerHeader } from '../../../../web/components/MultiContainerHeader';
import { YouDidItGraphic } from '../../../../web/components/svgs/graphics/YouDidItGraphic';
import { baseStyleSheet } from '../../../../web/styles/styles';
import { styleSheet } from './styles';

interface IProps
	extends IEventLoggingComponentProps,
		IUserSessionComponentProps,
		IModalContext,
		RouteComponentProps<any>,
		IErrorMessageComponentProps {
	approval: CreateCampaignApprovalViewModel;
	className?: string;
	customMessaging?: string;
	hideHeader?: boolean;
	onRequestClose(): void;
	styles?: StyleDeclarationValue[];
}

class _BulkEmailApprovalConfirmation extends React.Component<IProps> {
	public componentDidMount() {
		const { logPageView } = this.props;

		logPageView('BulkEmailApprovalConfirmation');
	}

	public render() {
		const { className, customMessaging, styles, approval, onRequestClose, hideHeader } = this.props;
		return (
			<div
				className={`${css(styleSheet.container, ...(styles || []))} bulk-email-approval-confirmation ${
					className || ''
				}`}
			>
				{!hideHeader && (
					<MultiContainerHeader
						fullscreenHeader='Schedule Email for Clients: Completed'
						onFullscreenRequestBack={this.onFullscreenRequestBack}
					/>
				)}
				<div className={css(styleSheet.content)}>
					<YouDidItGraphic />
					<div className={css(styleSheet.title)}>Hey boo, you did it.</div>
					{customMessaging ? (
						<div className={css(styleSheet.message)}>{customMessaging}</div>
					) : (
						<>
							<div className={css(styleSheet.message)}>
								{`${
									approval.selectedUsers.length > 1
										? `${approval.selectedUsers.length} users`
										: approval.selectedUsers.getByIndex(0)?.name || ''
								} will be notified via email.`}
							</div>
							<div className={css(styleSheet.message)}>
								{`You can check back in to see if ${
									approval.selectedUsers.length > 1
										? 'they have'
										: `${approval.selectedUsers.getByIndex(0)?.name || ''} has`
								} approved the campaign.`}
							</div>
						</>
					)}
					<button className={css(baseStyleSheet.ctaButton, styleSheet.button)} onClick={onRequestClose}>
						<span>Close window</span>
					</button>
				</div>
			</div>
		);
	}

	private onFullscreenRequestBack = (e: React.MouseEvent<HTMLElement>) => {
		e.preventDefault();
		e.stopPropagation();
		const { parentModal } = this.props;
		parentModal?.onRequestClose();
	};
}

const BulkEmailApprovalConfirmationAsObserver = observer(_BulkEmailApprovalConfirmation);
const BulkEmailApprovalConfirmationWithContext = inject(
	FullScreenModalViewModelKey,
	ModalChildComponentContextKey
)(BulkEmailApprovalConfirmationAsObserver);
export const BulkEmailApprovalConfirmation = withEventLogging(BulkEmailApprovalConfirmationWithContext);
